define((require) => {
    "use strict";

    var ImprovedView = require("editor/zbone/ImprovedView"),
        template     = require("ui/dashboard/DashboardNavigationView.tpl");

    return ImprovedView.extend({

        className: "dashboard-navigation tabs tabs-no-border tabs-no-margin",

        template: template,

        _tab: null,

        _disabled: false,

        ui: {
            tabs: "a"
        },

        events: {
            "click .tab": function(event) {
                // Just in case (for browsers not supporting pointer-events: none)
                if (this._disabled) {
                    event.stopPropagation();
                    event.preventDefault();
                }
            }
        },

        initialize: function() {
            var self = this;

            // TODO: Consider collection view...?
            this.options.tabs.each((tab) => {
                self.listenTo(tab, "change:length", () => {
                    self.render();
                    self.setActiveTab(self._tab);
                });
            });
        },

        templateHelpers: function() {
            return {
                tabs: this.options.tabs
            };
        },

        /**
         * Disables the tabs by applying the <tt>.disabled</tt> class (see tabs.less).
         *
         * @param  {Boolean} value Boolean to toggle the disabled state.
         */
        disable: function(value) {
            this._disabled = value;

            this.$el.toggleClass("disabled", value);
        },

        /**
         * Convenience for disabling during the lifetime of the provided <tt>Promise</tt> instance.
         *
         * @param  {Promise} promise A <tt>Promise</tt> that once "completed" (resolved or failed) will
         *                           reset the disabled state.
         */
        disableUntil: function(promise) {
            this.disable(true);
            promise.always(this.disable.bind(this, false));
        },

        setActiveTab: function(tab) {
            if (tab) {
                this._tab = tab;
                this.ui.tabs.removeClass("active");
                this.$el.find("[data-tab='" + tab.get("slug") + "']").addClass("active");
            }
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/dashboard/DashboardNavigationView.js